if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();

        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };

        // Pagination dots
        this.pagination = this.elements.viewer.querySelector('.slider-pagination');
        if (this.pagination) {
          const slides = this.elements.viewer.querySelectorAll('.slider__slide');
          this.pagination.innerHTML = '';

          slides.forEach((slide, index) => {
            const dot = document.createElement('button');
            dot.className = 'slider-dot';
            dot.dataset.index = index;

            if (slide.classList.contains('is-active')) {
              dot.classList.add('is-active');
            }

            dot.addEventListener('click', () => {
              const mediaId = slide.dataset.mediaId;
              this.setActiveMedia(mediaId, false);
            });

            this.pagination.appendChild(dot);
          });
        }
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;
        const nextButtons = this.querySelectorAll('.slider-button--next');
        const prevButtons = this.querySelectorAll('.slider-button--prev');

        nextButtons.forEach((btn) => {
          btn.addEventListener('click', () => {
            const current = this.elements.viewer.querySelector('.slider__slide.is-active');
            const next = current.nextElementSibling || current.parentElement.firstElementChild;
            if (next) this.setActiveMedia(next.dataset.mediaId, false);
          });
        });

        prevButtons.forEach((btn) => {
          btn.addEventListener('click', () => {
            const current = this.elements.viewer.querySelector('.slider__slide.is-active');
            const prev = current.previousElementSibling || current.parentElement.lastElementChild;
            if (prev) this.setActiveMedia(prev.dataset.mediaId, false);
          });
        });

        this.elements.viewer.addEventListener(
          'slideChanged',
          debounce(this.onSlideChanged.bind(this), 500)
        );

        this.elements.thumbnails
          .querySelectorAll('[data-target]')
          .forEach((mediaToSwitch) => {
            mediaToSwitch.querySelector('button').addEventListener(
              'click',
              this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false)
            );
          });

        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) {
          this.removeListSemantic();
        }
      }

      // Update thumbnail on slide change
      onSlideChanged(event) {
        const mediaId = event.detail.currentElement.dataset.mediaId;

        if (this.pagination) {
          const slides = this.elements.viewer.querySelectorAll('.slider__slide');
          const dots = this.pagination.querySelectorAll('.slider-dot');

          slides.forEach((slide, i) => {
            dots[i].classList.toggle('is-active', slide.dataset.mediaId === mediaId);
          });
        }
        const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(thumbnail);
      }

      // Set active media
      setActiveMedia(mediaId, prepend) {
        const activeMedia = this.elements.viewer.querySelector(
          `.slider__slide[data-media-id="${mediaId}"]`
        );

        if (!activeMedia) return;

        // Remove old actives
        this.elements.viewer.querySelectorAll('.slider__slide').forEach((slide) => {
          slide.classList.remove('is-active');
        });

        activeMedia.classList.add('is-active');

        // Update pagination dots
        if (this.pagination) {
          const slides = this.elements.viewer.querySelectorAll('.slider__slide');
          const dots = this.pagination.querySelectorAll('.slider-dot');

          slides.forEach((slide, i) => {
            dots[i].classList.toggle('is-active', slide.dataset.mediaId === mediaId);
          });
        }

        // Scroll media into view
        window.setTimeout(() => {
          activeMedia.parentElement.scrollTo({
            left: activeMedia.offsetLeft,
            behavior: 'smooth',
          });
        });

        this.playActiveMedia(activeMedia);

        // Update counter display
        const allSlides = Array.from(this.elements.viewer.querySelectorAll('.slider__slide'));
        const currentIndex = allSlides.findIndex((slide) => slide.classList.contains('is-active'));
        const counterCurrent = this.querySelector('.slider-counter--current');
        if (counterCurrent) counterCurrent.textContent = currentIndex + 1;

        // Thumbnails
        if (this.elements.thumbnails) {
          const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
          this.setActiveThumbnail(activeThumbnail);
          this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
        }
      }

      // Set active thumbnail
      setActiveThumbnail(thumbnail) {
        if (!thumbnail) return;

        this.elements.thumbnails.querySelectorAll('button').forEach((b) => b.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);

        if (!this.elements.thumbnails.isSlideVisible(thumbnail, 10)) {
          this.elements.thumbnails.slider.scrollTo({
            left: thumbnail.offsetLeft,
          });
        }
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML =
            window.accessibilityStrings.imageAvailable.replace('[index]', position);

          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (this.stickyHeader) this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}